import { components } from "@certn/legacy-api/generated-schemas/people";

import { ValidationRuleType } from "./types";

export function requireAddressRule(): ValidationRuleType {
  return {
    isValid: (
      addresses: components["schemas"]["AddressesCheckField"]["value"]
    ) => addresses.some(({ end_date }) => !end_date),
  };
}
